import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getPreferredSupplierFilters,
  getPreferredVendorDistrictData,
  getPreferredVendorDetailsData,
  getPreferredVendorChartData,
  getPreferredVendorDetailsChart,
  updatePreferredSupplier,
  getPreferredVendorByL4,
  getPreferredSupplierExport,
} from "../../queries/apiQueries";
import { Button, SelectPicker, Radio, RadioGroup, Modal, useToaster, Notification } from "rsuite";
import "./preferredSupplier.scss";

import { FILTERDATA, TIMELINE } from "../../utils";
import { spendType, projectType } from "../constants";
import { appInsights } from "../router";
import Overview from "./overview";
import MainContent from "../../components/Layouts/MainContent";
import MainHeader from "../../components/Layouts/MainHeader";
import ToggleSwitch from "../../components/common/ToggleSwitch";
import { Segmented } from "antd";
import { Loader } from "../../components/common/Loader";

const PreferredSupplier = (props: any) => {
	const dispatch = useDispatch<any>();
	const [filtersLoading, setFiltersLoading] = useState(true);
	const [isVisible, setIsVisible] = useState(false);
	const [districtList, setDistrictList] = useState<Array<any>>([]);
	const [detailsData, setDetailsData] = useState<Array<any>>([]);
	const [chartData, setChartData] = useState<Array<any>>([]);
	const [pieChartData, setPieChartData] = useState<Array<any>>([]);
  	const [lineChartData, setLineChartData] = useState<Array<any>>([]);
	const [legendData, setLegendData] = useState<any>({});
	const [chartTableData, setChartTableData] = useState<Array<any>>([]);
	const [selectedDistrict, setSelectedDistrict] = useState<any>(null);
	const [selectedL4, setSelectedL4] = useState<any>(null);
  	const [exportData, setExportData] = useState<any>([]);
	const [target, setTarget] = useState("overview");
	const [isRightVisible, setIsRightVisible] = useState(false);

	const allFilters = useSelector(
		(state: any) => state.CommonReducer.allFilters
	);
	const token = useSelector((state: any) => state.CommonReducer.token);

	const toaster = useToaster();

	const [selectedSpendType, setSelectedSpendType] = useState(
		spendType.length && spendType[2].value
	);

	const [selectedProjectType, setSelectedProjectType] = useState(
    	projectType.length && projectType[2].value
  	);

	const [isLoading, setIsLoading] = useState(true);
	const [filterOptions, updateFilterOptions] = useState<any>({
		l1: new Array<{ l1: string }>(),
		l2: new Array<{ l2: string }>(),
		l3: new Array<{ l3: string }>(),
		district: new Array<{ district: string }>(),
	});
	const [selectedFilters, setSelectedFilters] = useState<any>({
		...allFilters });
	const [tableLoading, setTableLoading] = useState(false);
	const [page, setPage] = useState("overview");
	const [tab, setTab] = useState("overall");
	const [detailViewType, setDetailViewType] = useState("marginTrend");
	const [popUp, setPopUp] = useState(false);
	const [supplierPopupList, setSupplierPopupList] = useState([]);
	const [initialSupplierPopupList, setInitialSupplierPopupList] = useState([]);
	const didMount: any = useRef(false);

	const handlePopUpClose = () =>{
      	setSupplierPopupList(initialSupplierPopupList);
		setPopUp(false);
		}

	const handlePopUpConfirmClick = () => {

		updateSupplierList();

		setPopUp(false);
	}

  /* on changing project type */
   const projectTypeHandler = (e: any) => {
    setSelectedProjectType(e === null ? "All" : e);
  };

   const shiftSuppliers = (d:any)=>{
    let tmp:any = JSON.parse(JSON.stringify(supplierPopupList));
    tmp.map((item:any)=>{
      if (item.supplier == d.supplier){
        if(item.type == 'strategic'){
          item.type = 'tail';
        } else{
          item.type = 'strategic';
        }
      }
    })

    setSupplierPopupList(tmp);
  }


	useEffect(() => {
		appInsights.trackPageView({
			name: `Navigate to supplier consolidation by ${localStorage.getItem(
				"name"
			)}`,
		});
		if (token) {
			getFilters();
		}
	}, [token]);

	useEffect(() => {
		if (
			selectedFilters.l3.length == 1
		) {
			getDistrictList();
			setSelectedDistrict(null);
			setSelectedL4(null);
			setPage("overview");
		}
	}, [selectedSpendType, selectedProjectType]);

	    useEffect(() => {
    if (selectedFilters.l3.length == 1) {
      getChartTableData(selectedDistrict);
      getChartData(selectedDistrict);
      getPieChartData(selectedDistrict);
      getDetailsData()
      setSelectedL4(null)
    }
  }, [detailViewType]);

  useEffect(() => {
    if (selectedFilters.l3.length == 1 && page == 'details') {
      getDetailsData();
    }
  }, [page]);

  useEffect(() => {
    if (selectedFilters.l3.length == 1) {
      getFilters();
      setSelectedFilters({ l1:[], l2: [], l3: []});
      getDistrictList();
      setSelectedDistrict(null);
      setSelectedL4(null);
      setPage("overview")
    } else{
      getFilters();
      setSelectedFilters({ l1:[], l2: [], l3: []});
      setDistrictList([]);
      setSelectedDistrict(null);
      setSelectedL4(null);
      setPage("overview")
    }
  }, [tab]);

	const getDistrictList = async () => {
		let payload = {
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			spendType: selectedSpendType == "" ? [] : [selectedSpendType],
			implementedSku: tab == 'implimented'? true : false,
			projectType: selectedProjectType,
		};
		let res = await dispatch(getPreferredVendorDistrictData(payload));

		setDistrictList(res.data);
		// setIsLoading(false);
	};

	const getChartData = async (district: any = null) => {
		let payload = {
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			spendType: selectedSpendType == "" ? [] : [selectedSpendType],
			district: [district],
			implementedSku: tab == 'implimented'? true : false,
		};
		let res = await dispatch(getPreferredVendorChartData(payload));

		console.log(res?.data, 123);
		res?.data?.forEach((val: any) => {
			val?.data?.forEach((value: any) => {
				value.l4 = val?.l4;
				val[value?.master_vendor_name] = value?.vendorSpendPrcnt;
			});
		});
		setChartData(res.data);
		setLegendData(res.legend);
		// setIsLoading(false);
	};

	const getPieChartData = async (district:any=null) => {
		let payload = {
		l1: selectedFilters.l1,
		l2: selectedFilters.l2,
		l3: selectedFilters.l3,
		spendType: selectedSpendType == "" ? [] : [selectedSpendType],
		projectType: selectedProjectType,
		district: [district],
		implementedSku: tab == 'implimented'? true : false,
		};
		let res = await dispatch(getPreferredVendorDetailsChart(payload));
		setPieChartData(res.data);
		
		let suppliers:any = [];

		res?.data?.nonPreferredSupplier?.map((item:any)=>{
		suppliers.push({supplier:item, type:'tail'})
		})
		res?.data?.preferredSupplier?.map((item:any)=>{
		suppliers.push({supplier:item, type:'strategic'})
		})

		setSupplierPopupList(suppliers);
		setInitialSupplierPopupList(suppliers);

		let lineCData:any =[];
		res?.lineChart?.gmArray?.map((item:any)=>{
		lineCData.push({
			MonthName: item.month,
			gm: item.value? Number(item.value)*100 : null,
		})
		})
		res?.lineChart?.valueArray?.map((wItem:any,index:any)=>{
		lineCData[index].walletShare = wItem.value ? Number(wItem.value)*100 : null;
		})
		
		setLineChartData(lineCData);

		// setIsLoading(false);
  	};
	const updateSupplierList = async ()=>{

		let preferred:any =[];
		let nonPreferred:any=[];

		supplierPopupList.map((item:any)=>{
		if(item.type == 'strategic'){
			preferred.push(item.supplier);
		} else{
			nonPreferred.push(item.supplier);
		}
		})
		let payload = {
		nonPreferredSupplierList: nonPreferred,
		preferredSupplierList: preferred,
		l3: selectedFilters.l3[0],
		district: selectedDistrict,
		}
		let res = await dispatch(updatePreferredSupplier(payload));

		if(res.success){
		getPieChartData(selectedDistrict);
		} else {
		setSupplierPopupList(initialSupplierPopupList);
		}
		

	}

	const getChartTableData = async (district: any = null) => {
		let payload = {
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			spendType: selectedSpendType == "" ? [] : [selectedSpendType],
			district: [district],
			l4Enables: detailViewType == 'l4Level'? true : false,
			implementedSku: tab == 'implimented'? true : false,
			projectType: selectedProjectType,
		};
		let res = await dispatch(getPreferredVendorByL4(payload));

		setChartTableData(res.data);

		// setIsLoading(false);
	};

	const getDetailsData = async (l4: any = null) => {
		let payload:any = {
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			spendType: selectedSpendType == "" ? [] : [selectedSpendType],
			district: [selectedDistrict],
			l4Enables: detailViewType == 'l4Level'? true : false,
			implementedSku: tab == 'implimented'? true : false,
			projectType: selectedProjectType,
		};
		 if(l4){
			payload.l4= [l4];
		}
		let res = await dispatch(getPreferredVendorDetailsData(payload));

		setDetailsData(res?.data);

		// setIsLoading(false);
	};

	const exportExcelHandler = async () => {
      toaster.push(message, { placement: "topCenter" });
      let payload : any = {
        l1: selectedFilters.l1,
        l2: selectedFilters.l2,
        l3: selectedFilters.l3,
        spendType: selectedSpendType == "" ? [] : [selectedSpendType],
        district: [selectedDistrict],
        projectType: selectedProjectType,
      };
      if(selectedL4){
      payload.l4= [selectedL4];
      }
      let res = await dispatch(getPreferredSupplierExport(payload));
      res.map((item: any) => {
        // item.gm2024 = item.gm2024 ? `${(item.gm2024 * 100)?.toFixed(2)}%` : 0;
        // item.gm2025 = item.gm2025 ? `${(item.gm2025 * 100)?.toFixed(2)}%` : 0;
        item.cost = `$${item.cost?.toFixed(2)}`;
        item.costLy = `$${item.costLy?.toFixed(2)}`;
        item.prefferedFlag = item.master_vendor_name == item.preferredsupplier? 1 : 0;
      });
  
      setExportData(res);
    };
  

	/* Filters api call */
	const getFilters = async (
		payload: any = {},
		currentFilter: any = "all",
		fo: any = null
	) => {
		// setFiltersLoading(true);

		if(tab == 'implimented'){
			payload.implementedSku = true;
		}else {
			payload.implementedSku = false;
		}
		let res = await dispatch(getPreferredSupplierFilters(payload));
		res = res.data;
		console.log("lll", res);

		if (fo) {
			if (currentFilter === "l1") {
				updateFilterOptions({
					...fo,
					l2: [...res.l2],
					l3: [...res.l3],
				});
			} else if (currentFilter === "l2") {
				updateFilterOptions({
					...fo,
					l3: [...res.l3],
				});
			} else if (currentFilter === "l3") {
				updateFilterOptions({
					...fo,
				});
			}  else {
				updateFilterOptions({
					district: res.district,
					l1: res.l1,
					l2: res.l2,
					l3: res.l3,
				});
			}
		} else {
			if (currentFilter === "l1") {
				updateFilterOptions({
					...filterOptions,
					l2: [...res.l2],
					l3: [...res.l3],
				});
			} else if (currentFilter === "l2") {
				updateFilterOptions({
					...filterOptions,
					l3: [...res.l3],
				});
			} else if (currentFilter === "l3") {
				updateFilterOptions({
					...filterOptions,
				});
			}  else {
				updateFilterOptions({
					district: res.district,
					l1: res.l1,
					l2: res.l2,
					l3: res.l3,
				});
			}
		}

		setIsLoading(false);
		setFiltersLoading(false);
		return res;
	};

	/* Updating filter selection state  */
	const handleFilterUpdate = (value: any, filter: string) => {
		let x: string = filter;
		setSelectedFilters({ ...selectedFilters, [x]: [value] });
		selectedFilters[x] = [value];
		if (filter == "l1" || filter == "l2" || filter == "l3") {
			setSelectedDistrict(null);
			setPage("overview");
		}
		setSelectedL4(null);
	};

	/* Updating filter options based on selection (api) */
	const handleClose = (filter: string) => {
		if (filter === "l1") {
			setSelectedFilters({
				...selectedFilters,
				l2: [],
				l3: [],
			});
			getFilters(
				{ ...selectedFilters, l2: [], l3: [], },
				"l1"
			);
		} else if (filter === "l2") {
			setSelectedFilters({
				...selectedFilters,
				l3: [],
				
			});
			getFilters({ ...selectedFilters, l3: [],  }, "l2");
		} else if (filter === "l3") {
			// setIsLoading(true);
			setSelectedFilters({ ...selectedFilters,  });
			// getFilters({ ...selectedFilters }, "l3");
			if (selectedFilters.l3.length == 1 ) {
				getDistrictList();
				setSelectedDistrict(null);
			}
		}  else if (filter === "district") {
			setSelectedFilters({ ...selectedFilters });
			if (selectedFilters.l3.length == 1) {
				handleDistrictSelection(selectedFilters.district);
				setSelectedDistrict(selectedFilters.district[0]);
			}
		}
	};

	 const handleDistrictSelection = (district:any)=>{
		let d:any = Array.isArray(district)
				? district[0]
				: district
		getChartTableData(d);
		getChartData(d);
		getPieChartData(d);
	}


	const handleL4Selection = (l4: any) => {
		console.log(l4, 123);
		setSelectedL4(l4);
		getDetailsData(l4);
	};

	useEffect(() => {
		if (token) {
			if (!didMount.current) {
				setIsLoading(true);
				getFilters().then((options: any) => {
					if (selectedFilters.l3.length > 0) {
						getFilters(selectedFilters, "l3", options);
					} else if (selectedFilters.l2.length > 0) {
						getFilters(selectedFilters, "l2", options);
					} else if (selectedFilters.l1.length > 0) {
						getFilters(selectedFilters, "l1", options);
					}
				});
				// getSummaryData();
				didMount.current = true;
			} else {
				props.onFilterChange(selectedFilters);
			}
		}
	}, [selectedFilters]);

	/* on changing project type */
	const spendTypeHandler = (e: any) => {
		setSelectedSpendType(e === null ? "All" : e);
	};
	const handleToggleChange = (e: { target: { checked: any } }) => {
		setTarget(e.target.checked ? "details" : "overview");
	};

	return isLoading ? (
		<Loader />
	) : (
		<>
			<Modal
				backdrop={true}
				role="alertdialog"
				open={popUp}
				onClose={handlePopUpClose}
				size="xs"
			>
				<Modal.Header closeButton={false}>
				<div className="flex">
					<div className="text-center text-[2.5vh] w-full mb-[3vh]">
					Validate Strategic Suppliers
					</div>
					<Button
					onClick={handlePopUpClose}
					style={{ background: "#941c14" }}
					className="modal-close-btn h-[4vh]"
					>
					Close
					</Button>
				</div>
				</Modal.Header>
				<Modal.Body>
				<div className=" modal-scenario-select flex-col" key="scenario">
					{/* <div className="italic text-center w-full">Validate Strategic Suppliers</div> */}
					<div className="flex w-full justify-center gap-x-[4vw]">
					<div className="max-h-[40vh]  overflow-y-auto">
						<table className="popUpTable">
						<thead>
							<tr>
							<th>Strategic</th>
							<th>Action</th>
							</tr>
						</thead>
						<tbody>
							{supplierPopupList.map((d: any, index: any) => {
							return (
								d.type == 'strategic' ?
								<tr key={d.supplier}>
								<td>{d.supplier}</td>
								
								<td>
									<Button
									onClick={() => {
									shiftSuppliers(d);
									}}
									>
									Move to Tail
									</Button>
								</td>
								</tr> 
								: <></>
							);
							})}
						</tbody>
						</table>
					</div>
					<div className="max-h-[40vh] overflow-y-auto">
						<table className="popUpTable">
						<thead>
							<tr>
							<th>Tail</th>
							<th>Action</th>
							</tr>
						</thead>
						<tbody>
							{supplierPopupList.map((d: any, index: any) => {
							return (
								d.type == 'tail' ?
								<tr key={d.supplier}>
								<td>{d.supplier}</td>
								
								<td>
									<Button
									onClick={() => {
										shiftSuppliers(d);
									}}
									>
									Move to Strategic
									</Button>
								</td>
								</tr>
								: <></>
							);
							})}
						</tbody>
						</table>
					</div>
					</div>
				</div>
				</Modal.Body>
				<Modal.Footer className="scenario-modal-footer">
				<Button onClick={handlePopUpConfirmClick} className="modal-save-btn">
					Save
				</Button>
				</Modal.Footer>
			</Modal>
			<div className="supplier-consolidation-container w-full ">
				<MainHeader
					onVisibilityChange={setIsVisible}
					isRightVisible={isRightVisible}
					setIsRightVisible={setIsRightVisible}
					topContent={
						<>
							<div className="flex justify-between items-center w-full">
								<div className="text-left pageline">
									<span className="pagelinestart">
										Value Tracking
									</span>{" "}
									<span className="pagelineslash">/</span>{" "}
									<span className="pagelinesub">
										Preferred Supplier
									</span>
								</div>
							</div>
							<div className="execution-level-wrapper">
								<div className="execution-level-title">
									View By
								</div>
								<Segmented
									options={[
										{
											label: "Overview",
											value: "overview",
										},
										{ label: "Details", value: "details" },
									]}
									value={page}
									onChange={(value) => setPage(value)}
								/>
							</div>
						</>
					}
					bottomContent={
						<div className="flex gap-6 basis-[49%] justify-between">
							{[
								"l1",
								"l2",
								"l3",
							].map((filterEntity: string, index: number) => {
								if (
									filterEntity != "district" ||
									page === "details"
								) {
									return (
										<div className="sub-heading-text font-bold flex flex-col items-start">
											<span className="filterHead ">
												{ filterEntity}
											</span>
											<SelectPicker
												data={
													filterOptions[filterEntity]
														?.length
														? filterOptions[
																filterEntity
														  ]
														: []
												}
												labelKey={
													filterEntity == "supplier"
														? "vendor"
														: filterEntity
												}
												valueKey={
													filterEntity == "supplier"
														? "vendor"
														: filterEntity
												}
												value={
													selectedFilters[
														filterEntity
													]
														? selectedFilters[
																filterEntity
														  ][0]
														: []
												}
												cleanable={false}
												onClose={() =>
													handleClose(filterEntity)
												}
												onChange={(value: any) => {
													handleFilterUpdate(
														value,
														filterEntity
													);
												}}
												loading={filtersLoading}
											/>
										</div>
									);
								}
							})}
							<div className="sub-heading-text font-bold flex flex-col items-start">
								<span className="filterHead ">Spend Type</span>
								<SelectPicker
									data={spendType.length ? spendType : []}
									placeholder="All"
									value={selectedSpendType}
									
									defaultValue={
										spendType.length
											? spendType[0].value
											: ""
									}
									onChange={spendTypeHandler}
									cleanable={false}
								/>
							</div>
							<div className="sub-heading-text font-bold flex flex-col items-start">
								<span className="filterHead ">Project Type</span>
								<SelectPicker
									data={projectType.length ? projectType : []}
									placeholder="All"
									value={selectedProjectType}
									
									defaultValue={
										projectType.length
											? projectType[0].value
											: ""
									}
									onChange={projectTypeHandler}
									cleanable={false}
								/>
							</div>
						</div>
					}
				></MainHeader>
				<MainContent isVisible={isVisible} fullHeight={true}>
					{page == 'details' &&
						<div className="flex items-center text-black gap-x-4">
							<RadioGroup
							name="radio-group-inline"
							inline
							defaultValue={detailViewType}
							value={detailViewType}
							onChange={(value: any) => {
								setDetailViewType(value);
							}}
							>
							<Radio value="marginTrend" color="green">
								Wallet Share & Margin Trend Overall
							</Radio>
							<Radio value="l4Level" color="green">
								L4 Level -Detailed View
							</Radio>
							</RadioGroup>
						</div>
					}
					<div className="chart-flex h-[90%]" style={{alignItems:'flex-start'}}>
						<Overview
							data={districtList}
							detailsData={detailsData}
							chartTableData={chartTableData}
							chartData={chartData}
							pieChartData={pieChartData}
							lineChartData={lineChartData}
							legendData={legendData}
							handleDistrictRowClick = {(district:any)=>{
								handleDistrictSelection(district);
							}}
							l3={selectedFilters.l3}
							selectedDistrict ={selectedDistrict}
							updateSelectedDistrict = {(d:any)=>{
								setSelectedDistrict(d);
								setSelectedFilters({ ...selectedFilters, district: [d] });
							}}
							selectedL4 ={selectedL4}
							updateSelectedL4 = {(l:any)=>{
								handleL4Selection(l);
							}}
							exportData = {exportData}
							getExportData = {()=>{
								exportExcelHandler();
							}}
							page = {page} 
							detailViewType = {detailViewType}
							handleTabChange = {(page:any)=>{
								if(page==='details'){
								setPage("details");
								} else{
								setPage("overview");
								}
							}} 
							tableLoading={tableLoading}
							updatePopUp = {(value:any)=>setPopUp(value)}
						/>
					</div>
				</MainContent>
			</div>
		</>
	);
};

const message = (
  <Notification type={"info"} header={`Exporting...`} closable>
    <p>Your file is being created. It will be download automatically</p>
  </Notification>
);

const mapDispatchToProps = (dispatch: any) => ({
	onFilterChange: (data: any) => dispatch({ type: FILTERDATA, data: data }),
	onTimelineChange: (data: any) => dispatch({ type: TIMELINE, data: data }),
});
export default connect(null, mapDispatchToProps)(PreferredSupplier);
